<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="50" cy="50" r="14" stroke="black" stroke-width="4"/>
<path d="M79 50C79 33.9837 66.0163 21 50 21C33.9837 21 21 33.9837 21 50C21 66.0163 33.9837 79 50 79C57.5978 79 64.5132 76.0782 69.6838 71.2969" stroke="black" stroke-width="4"/>
<path d="M64 35.5V51.5C64 55.6421 67.3579 59 71.5 59V59C75.6421 59 79 55.6421 79 51.5V50" stroke="black" stroke-width="4"/>
</svg>

</template>
